import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_WARRANTY_ERROR_RATE = {
  'list': [],
  'loading': false,
};

export const warrantyErrorRate = (state, action) => {
  return createReducer(INITIAL_STATE_WARRANTY_ERROR_RATE, {
    [ActionTypes.FETCHING_WARRANTY_ERROR_RATE_REPORT]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WARRANTY_ERROR_RATE_REPORT]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.FETCHED_WARRANTY_ERROR_RATE_REPORT_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
